class Locations {
  pathname = '/';

  constructor(pathname = '/') {
    this.pathname = pathname;
  }

  home = () => this.pathname;

  dashboard = () => `${this.pathname}dashboard`;

  b2bThriftPlanList = () => `${this.pathname}companies`;

  b2bThriftPlan = (id?: number | string) => `${this.pathname}companies/${id !== undefined ? id : ':id'}`;

  csvTemplates = () => `${this.pathname}csv-templates`;

  csvTemplate = (id?: number | string) => `${this.pathname}csv-templates/${id !== undefined ? id : ':id'}`;

  documentTypes = () => `${this.pathname}document-types`;

  analyticsCron = () => `${this.pathname}analytics-cron`;

  documentType = (id?: number | string) => `${this.pathname}document-types/${id !== undefined ? id : ':id'}`;

  ledger = () => `${this.pathname}ledger`;

  ledgerB2c = () => `${this.pathname}ledger/b2c`;

  ledgerB2b = () => `${this.pathname}ledger/b2b`;

  uploadCompanyDocument = (id?: number | string) =>
    `${this.pathname}companies/${id !== undefined ? id : ':id'}/upload-document`;

  companyGroupList = () => `${this.pathname}companies/:companyId/groups`;

  companyGroup = (id?: number, action?: string) =>
    `${this.pathname}companies/${id !== undefined ? id : ':companyId'}/groups/${action || ':action'}`;

  companyWithdrawRequestList = () => `${this.pathname}companies/:companyId/withdraw-requests`;

  companyWithdrawRequest = (id?: number, action?: string) =>
    `${this.pathname}companies/${id !== undefined ? id : ':companyId'}/withdraw-requests/${action || ':action'}`;

  companyEmployeesList = () => `${this.pathname}companies/:companyId/employees`;

  companyEmployee = (companyId?: number | string, action?: string, employeeId?: number | string) => {
    const companySegment = companyId !== undefined ? companyId : ':companyId';
    const actionSegment = action !== undefined ? action : ':action';

    let employeeSegment = '';
    if (employeeId !== undefined) {
      employeeSegment = `/${employeeId}`;
    } else if (action === undefined) {
      employeeSegment = '/:employeeId?';
    }

    return `${this.pathname}companies/${companySegment}/employees/${actionSegment}${employeeSegment}`;
  };

  companyTreasury = (companyId?: number | string) =>
    `${this.pathname}companies/${companyId !== undefined ? companyId : ':companyId'}/treasury`;

  /** The onboarding steps, opened on purpose from an active treasury's operations page. */
  companyTreasuryOnboarding = (companyId?: number | string) => `${this.companyTreasury(companyId)}/onboarding`;

  companyDepartmentsList = () => `${this.pathname}companies/:companyId/departments`;

  companyDepartment = (companyId?: number, action?: string) =>
    `${this.pathname}companies/${companyId !== undefined ? companyId : ':companyId'}/departments/${
      action || ':action'
    }`;

  ratibiEmployeeList = () => `${this.pathname}companies/employees`;

  ratibiEmployee = (id?: number) => `${this.pathname}companies/employees/${id !== undefined ? id : ':id'}`;

  settings = () => `${this.pathname}settings`;

  notificationTemplateList = () => `${this.pathname}notification-templates`;

  emailTemplateList = () => `${this.pathname}email-templates`;

  employeeList = () => `${this.pathname}employee`;

  employee = (id?: number) => `${this.pathname}employee/${id !== undefined ? id : ':id'}`;

  userList = () => `${this.pathname}user`;

  earlySignupUserList = () => `${this.pathname}early-signup-user`;

  user = (id?: number) => `${this.pathname}user/${id !== undefined ? id : ':id'}`;

  userGroupList = () => `${this.pathname}user-group`;

  userGiftList = () => `${this.pathname}user-gift`;
  accountDeletionList = () => `${this.pathname}account-deletion-requests`;

  portfolioList = () => `${this.pathname}portfolio`;

  portfolio = (id?: number) => `${this.pathname}portfolio/${id !== undefined ? id : ':id'}`;

  benchmarkList = () => `${this.pathname}benchmark`;
  productTypeList = () => `${this.pathname}product-type`;

  benchmark = (id?: number) => `${this.pathname}benchmark/${id !== undefined ? id : ':id'}`;

  portfolioOrderList = () => `${this.pathname}portfolio-order`;

  orderExecutionList = () => `${this.pathname}order-execution`;

  orderExecution = (id?: string) => `${this.pathname}order-execution/${id !== undefined ? id : ':id'}`;

  portfolioOrder = (id?: string) => `${this.pathname}portfolio-order/${id !== undefined ? id : ':id'}`;

  subscribedPortfolioList = () => `${this.pathname}subscribed-portfolio`;

  subscribedPortfolio = (id?: number) => `${this.pathname}subscribed-portfolio/${id !== undefined ? id : ':id'}`;

  userPortfolioRequestList = () => `${this.pathname}user-portfolio-request`;

  userPortfolioRequest = (id?: number | string) =>
    `${this.pathname}user-portfolio-request/${id !== undefined ? id : ':id'}`;

  roleList = () => `${this.pathname}role`;

  role = (id?: number) => `${this.pathname}role/${id !== undefined ? id : ':id'}`;

  currencyList = () => `${this.pathname}currency`;

  currency = (id?: number) => `${this.pathname}currency/${id !== undefined ? id : ':id'}`;

  userCategoryList = () => `${this.pathname}user-category`;

  userCategory = (id?: number) => `${this.pathname}user-category/${id !== undefined ? id : ':id'}`;

  assetList = () => `${this.pathname}asset`;

  asset = (id?: number) => `${this.pathname}asset/${id !== undefined ? id : ':id'}`;

  indexFundList = () => `${this.pathname}index-fund`;

  Etfs = () => `${this.pathname}etfs`;

  indexFundNavList = () => `${this.pathname}index-fund-nav`;

  indexFund = (id?: number) => `${this.pathname}index-fund/${id !== undefined ? id : ':id'}`;

  indexFundNavHistory = (id?: number) => `${this.pathname}index-fund/${id !== undefined ? id : ':id'}/nav-history`;

  fundGeographicalFocus = () => `${this.pathname}fund-geographical-focus`;

  fundManager = () => `${this.pathname}fund-manager`;

  holdingCompany = () => `${this.pathname}company`;

  fundAssetClass = () => `${this.pathname}fund-asset-class`;

  fundValuationDays = () => `${this.pathname}fund-valuation-days`;

  fundValuationFrequency = () => `${this.pathname}fund-valuation-frequency`;

  actionList = () => `${this.pathname}action`;

  resourceList = () => `${this.pathname}resource`;

  rolePermissionList = () => `${this.pathname}role-permission`;

  rolePermissionList2 = () => `${this.pathname}role-permission2`;

  report = () => `${this.pathname}report`;

  reportHub = () => `${this.pathname}report/reports`;

  reportCashTransactions = () => `${this.pathname}report/cash-transactions`;

  reportUsers = () => `${this.pathname}report/users`;

  reportUserDetails = () => `${this.pathname}report/user-details`;

  reportFeeCalculations = () => `${this.pathname}report/fee-calculations`;

  reportFinanceUsers = () => `${this.pathname}report/finance-users`;

  reportPortfolioComposition = () => `${this.pathname}report/portfolio-composition`;

  reportPortfolioSnapshot = () => `${this.pathname}report/portfolio-snapshot`;

  reportOrders = () => `${this.pathname}report/orders`;

  reportPortfolioOrdersData = () => `${this.pathname}report/portfolio-orders-data`;

  reportAum = () => `${this.pathname}report/aum`;

  reportAccumulatedAum = () => `${this.pathname}report/accumulated-aum`;

  reportPortfolioDetails = () => `${this.pathname}report/portfolio-details`;

  reportPortfolioTotals = () => `${this.pathname}report/portfolio-totals`;

  reportCmaUsers = () => `${this.pathname}report/cma-users`;

  analytics = () => `${this.pathname}analytics`;

  payment = () => `${this.pathname}payment`;

  fee = () => `${this.pathname}fee`;

  userFee = (id: number) => `${this.pathname}user/${id}/?tab=fees`;

  userFeeDeductionList = () => `${this.pathname}user-fee-deduction`;

  userFeeDeduction = (id?: number | string) => `${this.pathname}user-fee-deduction/${id !== undefined ? id : ':id'}`;

  feeBatchList = () => `${this.pathname}fee-batch`;

  batchExecutionList = () => `${this.pathname}batch-execution`;

  batchExecution = (id?: string) => `${this.pathname}batch-execution/${id !== undefined ? id : ':id'}`;

  feeBatch = (id?: string) => `${this.pathname}fee-batch/${id !== undefined ? id : ':id'}`;

  feeConfigList = () => `${this.pathname}fee-config`;

  feeConfig = (id?: number) => `${this.pathname}fee-config/${id !== undefined ? id : ':id'}`;

  login = () => `${this.pathname}login`;

  forgotPassword = () => `${this.pathname}forgot-password`;

  promoCodes = () => `${this.pathname}promo-codes`;

  promoCodeUsages = (id?: number) => `${this.pathname}promo-codes/${id !== undefined ? id : ':id'}/usages`;

  signUp = () => `${this.pathname}sign-up`;

  ibanVerification = () => `${this.pathname}iban-verification`;

  bankLookupList = () => `${this.pathname}banks`;

  alpacaFeeList = () => `${this.pathname}alpaca-fees`;

  alpacaFeeReport = () => `${this.pathname}alpaca-fee-report`;

  notFound = () => `${this.pathname}404`;
}

export const locations = new Locations();
